import "./HeroStatusChip.css";

const ChevronDown = () => (
  <svg className="hero-status-chip-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
    <path d="m6 9 6 6 6-6" />
  </svg>
);

/**
 * Clickable hero status chip with dropdown affordance for drill-down popups.
 * Pass `chipClass` matching the dashboard (e.g. ed-status-chip, de-status-chip).
 */
const HeroStatusChip = ({ chipClass = "ed-status-chip", variant = "", onClick, ariaLabel, children, showChevron = true }) => {
  const classes = [chipClass, variant, onClick ? "clickable" : ""].filter(Boolean).join(" ");

  if (!onClick) {
    return <span className={classes}>{children}</span>;
  }

  return (
    <span
      className={classes}
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {children}
      {showChevron ? <ChevronDown /> : null}
    </span>
  );
};

export default HeroStatusChip;
